<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center align-center fh">
        <v-flex xs11 sm9 md5 style="margin-top: -20px;">
          <h3 class="text-center">Confirm Password</h3>
          <v-card class="elevation-24">
            <v-card-title class="py-0">
              <v-spacer></v-spacer>
              🚫
            </v-card-title>
            <v-card-text>
              <form @submit.prevent="confirmPass" autocomplete="off">
                <p class="error--text">You need to re-enter your password to perform this request!</p>
                <v-text-field type="password" label="Enter Your Password" v-model="user.password" required="required" name="Password" autocomplete="off" :error-messages="errors.password"></v-text-field>
                <v-btn type="submit" small class="primary pull-right" :loading="user.processing">Confirm Password</v-btn>
              </form>
              <br>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Guest'

  export default {
    name: 'ConfirmPassword',
    layout,
    props: [
      'errors'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Confirm Password',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        user: this.$inertia.form({
          password: '',
        })
      }
    },
    methods: {
      confirmPass () {
        this.user.post('/user/confirm-password')
      },
    },
  }
</script>
